import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import AirplanemodeActiveIcon from '@mui/icons-material/AirplanemodeActive';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import DashboardIcon from '@mui/icons-material/Dashboard';
import MapIcon from '@mui/icons-material/Map';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import { useMediaQuery, useTheme } from '@mui/material';
import Routes from 'config/routes-constant';
import cookie from 'helper/cookie';
import Paths from 'helper/paths';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import HeaderSidebar from './HeaderSidebar';

import * as S from './sidebar.styles';
import SidebarItem from './SidebarItems';

const Sidebar = () => {
  const theme = useTheme();
  const isTabletSize = useMediaQuery(theme.breakpoints.down('md'));

  const { t } = useTranslation();
  const navigate = useNavigate();
  const links = useRef([
    {
      key: 'dashboard',
      url: Routes.dashboard,
      icon: <DashboardIcon />,
    },
    {
      key: 'profile',
      url: Routes.profile,
      icon: <AccountCircleOutlinedIcon />,
    },
    {
      key: 'viewMiles',
      url: Routes.viewMiles,
      icon: <MapIcon />,
    },

    {
      key: 'claimMiles',
      url: Routes.claimMiles,
      icon: <AirplanemodeActiveIcon />,
    },
    {
      key: 'calculation',
      url: Routes.calculation,
      icon: <CalculateOutlinedIcon />,
    },
    {
      key: 'tickets',
      url: Routes.tickets,
      icon: <QuestionAnswerIcon />,
    },
    // {
    //   key: 'services',
    //   url: Routes.services,
    //   icon: <HomeRepairServiceIcon />,
    // },
    {
      name: 'Services',
      url: '/service',
      icon: <BusinessCenterOutlinedIcon />,
    },
    // {
    //     name: 'Support',
    //     url: '/support',
    //     icon: <SupportAgentOutlinedIcon />
    // },
  ]);

  const logout = () => {
    cookie.clean();
    navigate(Paths.Login.index().route);
  };

  return (
    <S.ParentSidebar>
      {!isTabletSize && (
        <S.Wrapper>
          <HeaderSidebar />
          <SidebarItem />
        </S.Wrapper>
      )}
    </S.ParentSidebar>
  );
};

export default Sidebar;
